module.exports = __webpack_public_path__ + "img/feature_buy_th.fdc0f12d.png";